import { useEffect, useState } from "react";
import { EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Col, Popconfirm, Row, Select, Space, Table, Tag, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { responseStatus } from "../../constants";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from "../../helpers/common";
import { Links } from "../../helpers/Links";
import { DeXuatNhuCauTaiSan, LoaiNhuCauTaiSan, TrangThaiDeXuatNhuCau } from "../../models/taisan/DeXuatNhuCauTaiSan";
import { layDSDexuatNhuCau, trinhDuyetDeXuat } from "../../services/deXuatNhuCauTaiSan";

const DanhSachDeXuatNhuCau = () => {
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([Links.DeXuatNhuCauTaiSan.ChiTiet, Links.DeXuatNhuCauTaiSan.Xem]);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<DeXuatNhuCauTaiSan[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loaiNhuCau, setLoaiNhuCau] = useState<number | undefined>();
    const [trangThai, setTrangThai] = useState<number | undefined>();

    const getTenLoaiNhuCau = (value?: number) => {
        switch (value) {
            case LoaiNhuCauTaiSan.MuaMoi:
                return "Mua mới";
            case LoaiNhuCauTaiSan.BanGiao:
                return "Bàn giao";
            case LoaiNhuCauTaiSan.SuaChua:
                return "Sửa chữa";
            case LoaiNhuCauTaiSan.DieuChuyen:
                return "Điều chuyển";
            default:
                return "Không xác định";
        }
    };

    const getTrangThaiInfo = (value?: number) => {
        switch (value) {
            case TrangThaiDeXuatNhuCau.KhoiTao:
                return { label: "Khởi tạo", color: "default" };
            case TrangThaiDeXuatNhuCau.ThuHoi:
                return { label: "Thu hồi", color: "red" };
            case TrangThaiDeXuatNhuCau.TrinhLanhDaoPhong:
                return { label: "Trình LĐ Phòng", color: "blue" };
            case TrangThaiDeXuatNhuCau.LanhDaoPhongTraLai:
                return { label: "LĐ Phòng trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.ChuyenChanhVP:
                return { label: "Chuyển Chánh VP", color: "blue" };
            case TrangThaiDeXuatNhuCau.ChanhVPTraLai:
                return { label: "Chánh VP trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.CVVPThamMuu:
                return { label: "CV VP tham mưu", color: "cyan" };
            case TrangThaiDeXuatNhuCau.CVVPTraLai:
                return { label: "CV VP trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.TrinhPhoCVP:
                return { label: "Trình Phó CVP", color: "blue" };
            case TrangThaiDeXuatNhuCau.PhoCVPTraLai:
                return { label: "Phó CVP trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.TrinhCVP:
                return { label: "Trình CVP", color: "blue" };
            case TrangThaiDeXuatNhuCau.CVPTraLai:
                return { label: "CVP trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.TrinhPhoGiamDoc:
                return { label: "Trình Phó GĐ", color: "blue" };
            case TrangThaiDeXuatNhuCau.PhoGiamDocTraLai:
                return { label: "Phó GĐ trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.TrinhGiamDoc:
                return { label: "Trình GĐ", color: "blue" };
            case TrangThaiDeXuatNhuCau.GiamDocTraLai:
                return { label: "GĐ trả lại", color: "orange" };
            case TrangThaiDeXuatNhuCau.PheDuyet:
                return { label: "Đã phê duyệt", color: "green" };
            default:
                return { label: "Không xác định", color: "default" };
        }
    };

    const trangThaiOptions = [
        { value: TrangThaiDeXuatNhuCau.KhoiTao, label: "Khởi tạo" },
        { value: TrangThaiDeXuatNhuCau.ThuHoi, label: "Thu hồi" },
        { value: TrangThaiDeXuatNhuCau.TrinhLanhDaoPhong, label: "Trình LĐ Phòng" },
        { value: TrangThaiDeXuatNhuCau.LanhDaoPhongTraLai, label: "LĐ Phòng trả lại" },
        { value: TrangThaiDeXuatNhuCau.ChuyenChanhVP, label: "Chuyển Chánh VP" },
        { value: TrangThaiDeXuatNhuCau.ChanhVPTraLai, label: "Chánh VP trả lại" },
        { value: TrangThaiDeXuatNhuCau.CVVPThamMuu, label: "CV VP tham mưu" },
        { value: TrangThaiDeXuatNhuCau.CVVPTraLai, label: "CV VP trả lại" },
        { value: TrangThaiDeXuatNhuCau.TrinhPhoCVP, label: "Trình Phó CVP" },
        { value: TrangThaiDeXuatNhuCau.PhoCVPTraLai, label: "Phó CVP trả lại" },
        { value: TrangThaiDeXuatNhuCau.TrinhCVP, label: "Trình CVP" },
        { value: TrangThaiDeXuatNhuCau.CVPTraLai, label: "CVP trả lại" },
        { value: TrangThaiDeXuatNhuCau.TrinhPhoGiamDoc, label: "Trình Phó GĐ" },
        { value: TrangThaiDeXuatNhuCau.PhoGiamDocTraLai, label: "Phó GĐ trả lại" },
        { value: TrangThaiDeXuatNhuCau.TrinhGiamDoc, label: "Trình GĐ" },
        { value: TrangThaiDeXuatNhuCau.GiamDocTraLai, label: "GĐ trả lại" },
        { value: TrangThaiDeXuatNhuCau.PheDuyet, label: "Đã phê duyệt" },
    ];

    const loadData = async (filterLoaiNhuCau = loaiNhuCau, filterTrangThai = trangThai) => {
        try {
            setLoading(true);
            const result = await layDSDexuatNhuCau(undefined, filterLoaiNhuCau, filterTrangThai);
            setData(result || []);
        } catch (error: any) {
            toast.error(error.message || "Lỗi khi tải dữ liệu");
        } finally {
            setLoading(false);
        }
    };

    const handleTimKiem = () => {
        setCurrentPage(1);
        loadData(loaiNhuCau, trangThai);
    };

    const handleTrinhDuyet = async (id: number) => {
        try {
            const response = await trinhDuyetDeXuat(id);
            if (response.trangThai === responseStatus.thanhCong) {
                toast.success("Trình lãnh đạo phòng thành công");
                await loadData(loaiNhuCau, trangThai);
            } else {
                toast.error(response.thongBao || "Trình lãnh đạo phòng không thành công");
            }
        } catch (error: any) {
            toast.error(error.message || "Lỗi khi trình lãnh đạo phòng");
        }
    };

    const columns = [
        {
            title: "STT",
            key: "stt",
            width: 60,
            render: (_: any, __: any, index: number) => (currentPage - 1) * pageSize + index + 1,
        },
        {
            title: "Loại nhu cầu",
            dataIndex: "loaiNhuCau",
            key: "loaiNhuCau",
            width: 130,
            render: (value: number) => getTenLoaiNhuCau(value),
        },
        {
            title: "Tên tài sản",
            dataIndex: "tenTaiSan",
            key: "tenTaiSan",
            width: 200,
            render: (value: string, record: DeXuatNhuCauTaiSan) => (
                <div>
                    <div><b>{value || "-"}</b></div>
                    {record.maTaiSan && <Tag color="cyan" style={{ fontSize: 11 }}>{record.maTaiSan}</Tag>}
                </div>
            ),
        },
        {
            title: "Phân loại",
            dataIndex: "phanLoaiTaiSan",
            key: "phanLoaiTaiSan",
            width: 120,
            render: (value: number, record: DeXuatNhuCauTaiSan) => {
                if (record.tenPhanLoaiTaiSan) return <Tag color={value === 3 ? "geekblue" : "purple"}>{record.tenPhanLoaiTaiSan}</Tag>;
                if (value === 3) return <Tag color="geekblue">CCDC</Tag>;
                if (value === 1) return <Tag color="purple">TSCĐ</Tag>;
                return "-";
            },
        },
        {
            title: "SL",
            dataIndex: "soLuong",
            key: "soLuong",
            width: 80,
            align: "center" as const,
            render: (value: number, record: DeXuatNhuCauTaiSan) => `${value || 1} ${record.donViTinh || ""}`.trim(),
        },
        {
            title: "Cá nhân đăng ký",
            dataIndex: "hoTenCaNhan",
            key: "hoTenCaNhan",
            width: 160,
            render: (value: string) => value || "-",
        },
        {
            title: "Đơn vị",
            dataIndex: "tenDonVi",
            key: "tenDonVi",
            width: 180,
            render: (value: string) => value || "-",
        },
        {
            title: "Ghi chú",
            dataIndex: "moTa",
            key: "moTa",
            ellipsis: true,
        },
        {
            title: "Trạng thái",
            dataIndex: "trangThai",
            key: "trangThai",
            width: 140,
            render: (value: number) => {
                const info = getTrangThaiInfo(value);
                return <Tag color={info.color}>{info.label}</Tag>;
            },
        },
        {
            title: "Ngày tạo",
            dataIndex: "ngayKhoiTao",
            key: "ngayKhoiTao",
            width: 110,
            render: (value: Date) => value ? dateCommon.formatDate(value) : "-",
        },
        {
            title: "Thao tác",
            key: "action",
            width: 150,
            align: "center" as const,
            fixed: "right" as const,
            render: (_: any, record: DeXuatNhuCauTaiSan) => {
                const isCreator = record.idNVKhoiTao === user?.idNhanVien || record.idNVKhoiTao === user?.id;
                const canEdit = isCreator && menu[Links.DeXuatNhuCauTaiSan.ChiTiet];
                const canView = menu[Links.DeXuatNhuCauTaiSan.Xem] || canEdit;
                const canSubmit = isCreator && [
                    TrangThaiDeXuatNhuCau.KhoiTao,
                    TrangThaiDeXuatNhuCau.ThuHoi,
                    TrangThaiDeXuatNhuCau.LanhDaoPhongTraLai,
                ].includes(record.trangThai);

                return (
                    <Space>
                        {canSubmit && (
                            <Popconfirm
                                title="Trình lãnh đạo phòng"
                                description="Bạn có chắc muốn trình lãnh đạo phòng?"
                                okText="Đồng ý"
                                cancelText="Hủy"
                                onConfirm={() => handleTrinhDuyet(record.id!)}
                            >
                                <Tooltip title="Trình lãnh đạo phòng">
                                    <Button
                                        type="primary"
                                        size="small"
                                        icon={<SendOutlined />}
                                    />
                                </Tooltip>
                            </Popconfirm>
                        )}
                        {canView && (
                            <Tooltip title="Xem chi tiết">
                                <Button
                                    size="small"
                                    icon={<EyeOutlined />}
                                    onClick={() => navigate(`${Links.DeXuatNhuCauTaiSan.Xem}?id=${record.id}`)}
                                />
                            </Tooltip>
                        )}
                        {canEdit && (
                            <Tooltip title="Chỉnh sửa">
                                <Button
                                    type="primary"
                                    size="small"
                                    icon={<EditOutlined />}
                                    onClick={() => navigate(`${Links.DeXuatNhuCauTaiSan.ChiTiet}?id=${record.id}`)}
                                />
                            </Tooltip>
                        )}
                    </Space>
                );
            },
        },
    ];

    useEffect(() => {
        if (user) {
            loadData();
        }
    }, [user?.idDonVi]);

    return (
        <section>
            <ContentHeader title="Danh sách đề xuất nhu cầu tài sản" />
            <Row className="form-group" gutter={[8, 8]}>
                <Col xs={24} sm={12} md={6}>
                    <Select
                        allowClear
                        placeholder="Loại nhu cầu"
                        style={{ width: "100%" }}
                        options={[
                            { label: "Mua mới", value: LoaiNhuCauTaiSan.MuaMoi },
                            //{ label: "Bàn giao", value: LoaiNhuCauTaiSan.BanGiao },
                            { label: "Sửa chữa", value: LoaiNhuCauTaiSan.SuaChua },
                            //{ label: "Điều chuyển", value: LoaiNhuCauTaiSan.DieuChuyen },
                        ]}
                        value={loaiNhuCau}
                        onChange={(value) => setLoaiNhuCau(value)}
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Select
                        allowClear
                        placeholder="Trạng thái"
                        style={{ width: "100%" }}
                        options={trangThaiOptions}
                        value={trangThai}
                        onChange={(value) => setTrangThai(value)}
                    />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                        <Tooltip title="Tìm kiếm">
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleTimKiem}>
                                Tìm kiếm
                            </Button>
                        </Tooltip>
                        {menu[Links.DeXuatNhuCauTaiSan.ChiTiet] && (
                            <Tooltip title="Thêm mới">
                                <Button
                                    className="hrm-btn hrm-btn-warning"
                                    icon={<PlusOutlined />}
                                    onClick={() => navigate(Links.DeXuatNhuCauTaiSan.ChiTiet)}
                                >
                                    Thêm mới
                                </Button>
                            </Tooltip>
                        )}
                    </Space>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            <Table
                                columns={columns}
                                dataSource={data}
                                loading={loading}
                                rowKey="id"
                                scroll={{ x: 1200 }}
                                pagination={{
                                    current: currentPage,
                                    pageSize,
                                    total: data.length,
                                    showSizeChanger: true,
                                    showTotal: (total) => `Tổng số: ${total}`,
                                    onChange: (page, size) => {
                                        setCurrentPage(page);
                                        setPageSize(size);
                                    },
                                }}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachDeXuatNhuCau;
